import API from "Api";
import { generateDynamicEndpoint } from "utils/generalUtils";
import {
  GET_STAFF_LIST_ENDPOINT,
  CREATE_STAFF_ENDPOINT,
  UPDATE_STAFF_ENDPOINT,
  DELETE_STAFF_ENDPOINT,
} from "./endpoints";

//Get staff List
export const getStaffListAPI = (payload) => {
  return API.post(GET_STAFF_LIST_ENDPOINT, payload);
};

// Create staff
export const createStaffAPI = (payload) => {
  return API.post(CREATE_STAFF_ENDPOINT, payload);
};

//Update staff
export const updateStaffAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_STAFF_ENDPOINT, { staff_id: id }),
    payload
  );
};

//Delete staff
export const deleteStaffAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_STAFF_ENDPOINT, { staff_id: id })
  );
};
